export const FREQUENCIES = {
  MONTH: 'month',
  QUARTER: 'quarter',
} as const;

export const YEARS = {
  MULTI: 'multi',
  CURRENT: 'current',
  CALENDAR: 'calendar',
} as const;

export const VIEWS = {
  TABLE: 'table',
  CHART: 'chart',
} as const;

export const Constants = {
  TAG_NAME: 'pop-total-returns-component',
  COMPONENT_TITLE: 'Total returns',
  NESTED_COMPONENTS: [
    'pop-total-returns-table-component',
    'pop-total-returns-chart-component',
  ],
  FREQUENCIES: [FREQUENCIES.MONTH, FREQUENCIES.QUARTER],
  YEARS: [YEARS.MULTI, YEARS.CURRENT, YEARS.CALENDAR],
  VIEWS: [VIEWS.TABLE, VIEWS.CHART],
  DEFAULT_FREQUENCY: FREQUENCIES.QUARTER,
  DEFAULT_YEARS: YEARS.MULTI,
  DEFAULT_VIEW: VIEWS.TABLE,
  AS_OF_DATE_PREFIX: 'composite data as of',
  MONTHLY_YTD: 'Monthly YTD',
  ONE_MONTH: '1 month',
  THREE_MONTHS: '3 months',
  TOTAL_RETURNS_UNAVAILABLE: 'Total returns unavailable',
  ANNUALIZED_PERFORMANCE_UNAVAILABLE: 'Annualized performance unavailable',
  CURRENT_YEAR_PERFORMANCE_UNAVAILABLE: 'Current year performance unavailable',
  CALENDAR_YEAR_PERFORMANCE_UNAVAILABLE:
    'Calendar year performance unavailable',
  PURE_GROSS:
    '"Pure" Gross<span data-disclaimer-code="SMA-TotalRtrnNetAnnEqMA"></span>',
  NET: 'Net<span data-disclaimer-code="SMA-TotalRtrnNetAnnEqMA"></span>',
  PURE_GROSS_FIXED_INCOME:
    '"Pure" Gross<span data-disclaimer-code="SMA-TotalRtrnNetAnnFI"></span>',
  NET_FIXED_INCOME:
    'Net<span data-disclaimer-code="SMA-TotalRtrnNetAnnFI"></span>',
  BENCHMARK: 'Benchmark',
  BENCHMARK_PREFIX: 'Benchmark: ',
  VALUE_PURE_GROSS: 'Value added ("Pure" Gross)',
  VALUE_NET: 'Value added (Net)',
  ONE_YEAR: '1 year',
  THREE_YEAR: '3 year',
  FIVE_YEAR: '5 year',
  TEN_YEAR: '10 year',
  SINCE_INCEPTION: 'Since inception',
  END_DATE: 'End date',
  VIEW_DROPDOWN_ID: 'view-select',
  VIEW: 'View',
  MONTH_END: 'Month end',
  QUARTER_END: 'Quarter end',
  TABLE: 'Table',
  CHART: 'Chart',
  ANNUALIZED_TITLE: 'Annualized',
  CURRENT_YEAR_TITLE: 'Current year',
  CALENDAR_YEAR_TITLE: 'Calendar year',
  EMPTY_CELL_VALUE: 'N/A',
} as const;
